import React, { useState, useEffect } from 'react'
import './index.scss'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faPython,
  faNodeJs,
  faGitAlt,
  faDocker,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'

function About() {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    const timeout = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'B', 'O', 'U', 'T', ' ', 'M', 'E']}
              idx={15}
            />
          </h1>
          <p>
            I am a highly motivated Fullstack Developer with a background in
            Electrical Engineering from Brawijaya University. My transition from
            hardware to software has shaped me into a versatile engineer who
            thrives on solving complex architectural challenges.
          </p>
          <p align="LEFT">
            I specialize in building scalable backend systems using Golang and
            Python, adhering to Clean Architecture principles. My recent work
            focuses on integrating cutting-edge AI technologies, specifically
            RAG (Retrieval-Augmented Generation) pipelines and Vector Databases
            to build intelligent SaaS platforms.
          </p>
          <p>
            If I need to define myself in one sentence that would be a
            tech-driven problem solver, a microservices enthusiast, and someone
            who is constantly exploring the intersection of AI and enterprise
            automation.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faPython} color="#4B8BBE" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faNodeJs} color="#3C873A" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faDocker} color="#2496ED" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ed4f4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#efd81d" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#ec4e28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
